$(document).ready(function () {
  // Initialise des data target cliquables
  initURLTarget();

  // FAQ
  if ($(".faq").length) {
    $(".faq_title").click(function (e) {
      $(this).toggleClass('open');
      $(this).next(".faq_answer").slideToggle(250, "linear", function () { $(this).toggleClass("opened"); });
      var arrow = $(this).find("span.arrow");
      if (arrow.text() == "+") {
        arrow.text("-");
      } else {
        arrow.text("+");
      }
    });
  }

  // Initialisation des swiper
  initSwipers();


  $('media-gallery').each(function () {
    const $mediaGallery = $(this);
    const $sliderComponent = $mediaGallery.find('slider-component');

    if ($sliderComponent.length) {
      $sliderComponent.each(function () {
        initProgress($(this));
      });
    }
  });

});

// Écoute des clics sur tous les éléments ayant l'attribut 'data-url_target'
function initURLTarget() {
  $("[data-url_target]").click(function () {
    var url = $(this).data("url_target");
    if (url && url !== "#") {
      window.location.href = url;
    }
  });
}

// Initialisation des Swipers de carte produit
function initSwipers() {
  document.querySelectorAll('.swiper').forEach((swiperEl, index) => {
    let swiper = new Swiper(swiperEl, {
      direction: 'horizontal',
      loop: true,
      speed: 200,
      effect: 'fade', // Par défaut "slide" sur mobile
      fadeEffect: {
        crossFade: true
      },
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
      },
      navigation: {
        enabled: false,
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      scrollbar: {
        el: '.swiper-scrollbar'
      }
    });

    // Ajout de l'effet hover sur la carte produit
    let productCard = swiperEl.closest('.product_item'); // S'assurer qu'on cible bien la carte produit
    if (productCard) {
      productCard.addEventListener('mouseenter', () => {
        swiper.slideTo(1); // Passe à la deuxième image
      });

      productCard.addEventListener('mouseleave', () => {
        swiper.slideTo(0); // Retourne à la première image
      });
    }
  });
}

function initProgress($component) {
  const $slider = $component.find('.product__media-list');
  const $slides = $slider.find('li.slider__slide');
  const $progressStep = $component.find('.progress .step');

  if ($slides.length === 0 || $progressStep.length === 0) return;

  const totalSlides = $slides.length;
  const stepWidth = 100 / totalSlides;

  // Largeur initiale de la barre
  $progressStep.css('width', stepWidth + '%');

  const updateStepPosition = () => {

    let activeIndex = 0;
    const sliderRect = $slider[0].getBoundingClientRect();

    $slides.each(function (index) {
      const slideRect = this.getBoundingClientRect();

      const isVisible = (
        slideRect.left >= sliderRect.left &&
        slideRect.right <= sliderRect.right
      );

      if (isVisible) {
        activeIndex = index;
        return false; // break loop
      }
    });

    const leftPercent = activeIndex * stepWidth;
    $progressStep.css('left', leftPercent + '%');
  };

  // Écoute le scroll horizontal du slider
  $slider.on('scroll', debounce(updateStepPosition, 50));

  // Position initiale
  updateStepPosition();
}